import { post, postJson, filePost, postFileDownload } from '@/utils/request';

/******** 委托录入 Start ********/
// 导入excel获取信息
export const readEntrustmentSetFromExcel = params => {
  return filePost(`/app/etmt/readEntrustmentSetFromExcel`, params);
};
// 新增/编辑委托信息
export const editEntrustmentSetJson = params => {
  return postJson(`/app/etmt/editEntrustmentSetJson`, params);
};
// 编辑委托中的特殊说明
export const editEntrustmentNote = params => {
  return post(`/app/etmt/editEntrustmentNote`, params);
};
// 获取委托信息列表
export const getEntrustmentSetList = params => {
  return post(`/app/etmt/getEntrustmentSetList`, params);
};
// 获取委托信息详情
export const getEntrustmentSet = params => {
  return post(`/app/etmt/getEntrustmentSet`, params);
};
// 删除委托信息
export const deleteEntrustmentSet = params => {
  return post(`/app/etmt/deleteEntrustmentSet`, params);
};
// 获取当前最大委托编号
export const getReportCodeMax = params => {
  return post(`/app/etmt/getReportCodeMax`, params);
};
/******** 委托录入 End ********/

/******** 委托协议书 Start ********/
// 列表
export const getEntrustmentList = params => {
  return post(`/app/etmt/getEntrustmentList`, params);
};
// 编辑
export const editEntrustmentJson = params => {
  return postJson(`/app/etmt/editEntrustmentJson`, params);
};
// 详情
export const getEntrustment = params => {
  return post(`/app/etmt/getEntrustment`, params);
};
// 删除
export const deleteEntrustment = params => {
  return post(`/app/etmt/deleteEntrustment`, params);
};
/******** 委托协议书 End ********/

// 接样
export const editEntrustmentReceipt = params => {
  return post(`/app/etmt/editEntrustmentReceipt`, params);
};

// #region ******** 现场检测-设备材料检测 ********
// 现场设备材料列表
export const getTotEntrustmentList = params => {
  return post(`/app/tot/getTotEntrustmentList`, params);
};
// 新增/编辑
export const editTotEntrustmentJson = params => {
  return postJson(`/app/tot/editTotEntrustmentJson`, params);
};
// 导入excel获取信息
export const readTotEntrustmentFromExcel = params => {
  return filePost(`/app/tot/readTotEntrustmentFromExcel`, params);
};
// 详情
export const getTotEntrustment = params => {
  return post(`/app/tot/getTotEntrustment`, params);
};
// 详情
export const deleteTotEntrustment = params => {
  return post(`/app/tot/deleteTotEntrustment`, params);
};
// 获取最大委托编号
export const getTotEntrustmentReport = params => {
  return post(`/app/tot/getTotEntrustmentReport`, params);
};
// #endregion **** 现场检测-设备材料检测 ********

// #region ******** 现场检测-工程质量检测 ********
// 列表
export const getProjectList = params => {
  return post(`/app/tot/getProjectList`, params);
};
// 新增/编辑 工程
export const editProject = params => {
  return post(`/app/tot/editProject`, params);
};
// 详情 工程
export const getProject = params => {
  return post(`/app/tot/getProject`, params);
};
// 删除 工程
export const deleteProject = params => {
  return post(`/app/tot/deleteProject`, params);
};
// 阶段列表
export const getProjectStageList = params => {
  return post(`/app/tot/getProjectStageList`, params);
};
// 获取数据抽查模版项目列表
export const getTotTemplateList = params => {
  return post(`/app/tot/getTemplateList`, params);
};
// 导出数据抽查模版
export const exportReportInvoiceCodeList = params => {
  return postFileDownload(`/app/tot/exportReportInvoiceCodeList`, params, { responseType: 'blob' });
};
// 检测量统计
export const getCheckNumByUser = params => {
  return post(`/app/tot/getCheckNumByUser`, params);
};
// #endregion **** 现场检测-工程质量检测 ********

// 企业官网线上委托
export const getOnlineEntrustmentList = params => {
  return post(`/app/getOnlineEntrustmentList`, params);
};

// 处理线上委托
export const handleEntrustment = params => {
  return post(`/app/handleEntrustment`, params);
};

// 待处理线上委托数量
export const handleTodo = params => {
  return post(`/app/handleTodo`, params);
};
